/**
 * Copyright 2025 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */

// opcua/umati/v3/json/metadata/isw/gateway/ShowcaseMachineTool
// opcua/umati/v3/json/data/isw/gateway/ShowcaseMachineTool

export default class PubSubTopics {
  static base() {
    return 'opcua/umati/v3/json';
  }

  static List(specificationId = '+') {
    return `${PubSubTopics.base()}/+/+/list/${specificationId}`;
  }

  static FaultyList(kindOfFault = '+') {
    return `${PubSubTopics.base()}/+/+/bad_list/${kindOfFault}`;
  }

  static Metadata(subTopic: string) {
    return `${PubSubTopics.base()}/metadata/${subTopic}`;
  }
  static MetadataWildcard(subTopic: string) {
    return `${PubSubTopics.Metadata(subTopic)}/#`;
  }

  static Data(subTopic: string) {
    return `${PubSubTopics.base()}/data/${subTopic}`;
  }
  static DataWildcard(subTopic: string) {
    return `${PubSubTopics.Data(subTopic)}/#`;
  }
}
